module.exports = __webpack_public_path__ + "a85e332e699c2039e0d754f4e71e2b01.pdf";